export default __webpack_public_path__ + "static/media/bf.f381789e.svg";